<template>
  <div class="kecheng">
    <kind-choose-view :show-kc="false" :type="116" @isOk="isOk" />
    <div class="home-two-title">
      <div class="text">
        <slot>最近直播</slot>
      </div>
    </div>
    <div v-if="list && list.length > 0" class="live">
      <div v-for="(item, index) in list" :key="index" class="item">
        <div style="overflow: hidden;" class="item-img">
          <img style="width: 100%;height: auto;" :src="item.img">
        </div>
        <div class="detail">
          <div class="detail-title twoEllipsis">{{ item.title }}</div>
          <div class="flex-between-c m-t-16">
            <div class="tips">
              {{ item.startTime | format("MM月dd日 HH:mm") }} 开播
            </div>
            <div class="keep-learn keep-check" @click="godetail(item)">
              立即观看
            </div>
          </div>
          <div class="detail-ter flex-between-c m-t-20">
            <div class="ter-list">
              <div class="terbox">
                <el-image class="ter-img" :src="item ? item.teacherImg : ''" fit="cover" />
              </div>
              <span class="ter">讲师：{{ item.teacherName }}</span>
            </div>
            <div class="tips">人气值 {{ item.clicks ? item.clicks : 0 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!list || list.length == 0" class="nothing">
      <div class="nothing-text">暂无内容哦~</div>
    </div>
    <div class="flex-jc-c m-t-20">
      <el-pagination :total="total" :current-page="pageNum" :page-sizes="[8, 16, 24, 40]" :page-size="pageSize"
        :pager-count="5" layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" />
    </div>
    <el-dialog title="提示" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="ifHave" width="400px" center>
      <span>尚未购买无法观看</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ifHave = false">取消</el-button>
        <el-button v-if="!$store.state.hidePurchaseButtons" type="primary" @click="goOrder">去购买</el-button>
      </span>
    </el-dialog>
    <div v-if="showLookDetail" class="lookBg">
      <div class="ifLook">
        <div class="prompt">提示</div>
        <div class="contents">
          您当前正在<span>{{ lookDeatil ? lookDeatil.terminal : "" }}</span>观看<span>{{ lookDeatil ? lookDeatil.chapterName :
            "" }}</span>,请关闭后再行观看其他章节。
        </div>
        <div class="button" @click="closeLook">关闭</div>
      </div>
    </div>
  </div>
</template>
<script>
import KindChooseView from '@/components/kindChooseViewjpkc.vue'
import Vue from 'vue'
// import {  courseCheckPlay } from '@/api/know'

import { getInfo } from '@/api/cookies'
// import { getLbClassCourseById } from '@/api/home'
// import { OrderClient } from '@/api/orderClient'
// const orderClient = new OrderClient()
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {
    KindChooseView
  },
  data() {
    return {
      search: {},
      list: [],
      total: 0,
      userInfo: null,
      pageSize: 8,
      pageNum: 1,
      loading: null,
      ifHave: false,
      liveId: null,
      liveshowName: '',
      live: null,
      lookDeatil: null,
      showLookDetail: false
    }
  },
  async beforeDestroy() {
    this.loading.close()
  },
  created() {
    this.userInfo = getInfo()
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.2)'
      })
      await homeClient
        .getLiveshowplaybackByTypes(
          {
            pageSize: this.pageSize,
            pageNum: this.pageNum,
            kind: this.search.kind ? this.search.kind : null,
            zyId: this.search.zyId ? this.search.zyId : null,
            areaIds: this.search.areaId ? this.search.areaId : null
          }
        )
        .then((res) => {
          this.total = res.total
          this.list = res.data.rows
        })
      this.loading.close()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    isOk(val) {
      this.search = val
      this.getList()
    },


    async godetail(item) {
      if (!this.userInfo) {
        Vue.prototype.goLoginView(true)
        return
      }
      this.liveId = item.liveId
      this.liveshowName = item.liveshowName
      // await getLiveshowplaybackByTypes(item.liveId).then((res) => {
      //   this.ifHave = !res.data.IsPurchase
      //   this.live = res.data.details
      // })
      await homeClient.checkIsBuyByCommodityId({
        liveId: item.liveId||item.courseId,
      }).then((res) => {
        if (res.code == 0) {
          this.ifHave = !res.data
        }
      })
      if (this.ifHave) {
        return
      }
      if (item.liveCourseStatus == 0) {
        this.$message.error('课程还未到开播时间')
        return
      }
      if (item.liveCourseStatus == 2) {
        this.$message.error('课程直播结束')
        return
      }
      const sub = {
        id: item.id, 
      };
      for (const key in sub) {
        if (!sub[key] && sub[key] !== 0) {
          delete sub[key];
        }
      }
      const data = Vue.prototype.export(sub);
      const routeUrl = this.$router.resolve({
        path: `/livebofang?${data}`,
      });
      if (item.liveCourseStatus == 3 || item.liveCourseStatus == 1) {
        window.open(routeUrl.href, "_blank");
      } else {
        this.$notify({
          title: "提示",
          message: "该视频暂不可播放",
          type: "warning",
        });
      }


    },
    closeLook() {
      this.showLookDetail = false
    },
    goOrder() {
      if (this.userInfo) {
        let arr = [];
        let obj = {
          commodityTypeCode: 1,
          commodityId: this.liveId,
          discount: 0,
        };
        arr.push(obj);
        console.log(arr, 'arr');
        homeClient
          .addPayOrders(arr, undefined)
          .then((res) => {
            if (res.code == 0) {
              this.$router.push(`/orders/${res.data.orderNum}`)
            } else {
              // this.$message.error(res.msg)
            }
          })
      } else {
        Vue.prototype.goLoginView(true)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.live {
  width: 1244px;
  margin-left: calc(50% - 610px);
  flex-wrap: wrap;
  margin-bottom: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .item {
    width: 287px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    margin-right: 24px;
    margin-bottom: 24px;
    overflow: hidden;
    padding-bottom: 10px;

    &:hover {
      box-shadow: 0px 4px 8px 1px rgba(153, 153, 153, 0.20000000298023224);
    }

    .item-img {
      width: 287px;
      height: 161.4px;
      border-radius: 8px 8px 0px 0px;
      opacity: 1;
    }

    .detail {
      padding: 12px 16px;

      .detail-title {
        font-size: 18px;
        height: 52px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
      }

      .tips {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
      }
    }
  }
}

.home-two-title {
  width: 1220px;
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .contents {
      width: 380px;
      margin: 20px auto;

      &>span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
    }
  }
}
</style>
